"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageFile = void 0;
const storage_base_service_1 = require("./storage-base.service");
class StorageFile extends storage_base_service_1.StorageBase {
    constructor(parent, name) {
        super(parent, name);
    }
    getDownloadURL() {
        return this.root.getDownloadURL();
    }
}
exports.StorageFile = StorageFile;
